<template>
  <div class="CalendarWidget lxn-border-round lxn-overflow-hidden lxn-margin-auto">
    <div class="CalendarWidget-header lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
      {{dayOfWeek}}
    </div>
    <div class="CalendarWidget-body lxn-w100 lxn-title lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
      {{dayOfMonth}}
    </div>
  </div>
</template>

<script>
import moment from 'jalali-moment';

export default {
  name: 'CalendarWidget',
  props: {
    index: Number,
    editing: Boolean
  },
  components: {
  },
  data: function () {
    return {
    }
  },
  computed: {
    dayOfWeek: function () {
      if(this.$store.state.language == 'fa' || this.$store.state.language == 'dar'){
        var d = moment().locale('fa');
        return this.$store.getters.language.texts.weekDays[d.day()];
      }else{
        d = new Date();
        return this.$store.getters.language.texts.weekDays[d.getDay()];
      }
    },
    dayOfMonth: function () {
      if(this.$store.state.language == 'fa' || this.$store.state.language == 'dar'){
        var d = moment().locale('fa');
        return d.date() + ' ' + this.$store.getters.language.texts.months[d.month()];
      }else{
        d = new Date();
        return this.$store.getters.language.texts.months[d.getMonth()] + ' ' + d.getDate();
      }
    },
  },
  methods: {
  }
}
</script>

<style>
  .CalendarWidget {
    height: 110px;
    width: 110px;
    border-style: solid;
    border-width: 1px;
    border-color: #53636C;
  }
  .CalendarWidget-header {
    height: 30px;
    background-color: #53636C;
    line-height: 30px;
    color: #FFFFFF;
  }
  .CalendarWidget-body {
    height: 80px;
    background-color: #FFFFFF;
    line-height: 80px;
  }
</style>
